import type { MenuItem } from '@/types';

/**
 * Integration Guides docs menu
 */
export const integrationGuideMenu: MenuItem[] = [
  {
    label: 'Three Phases of Streaming',
    path: '/integration-guides/three-phases-of-streaming',
  },
  {
    label: 'Real-Time Use Cases',
    path: '/integration-guides/real-time-use-cases',
  },
  {
    label: 'Ingest Options',
    path: '/integration-guides/ingest-options',
    openNested: true,
    submenu: [
      { label: 'RTMP Setup', path: '/integration-guides/rtmp' },
      { label: 'RTSP Setup', path: '/integration-guides/rtsp' },
      { label: 'SRT Setup', path: '/integration-guides/srt' },
      { label: 'WHIP Setup', path: '/integration-guides/whip' },
    ],
  },
  {
    label: 'Encoders & Sources',
    path: '/integration-guides/3rd-party-encoders/encoder-overview',
    openNested: true,
    submenu: [
      { label: 'AWS Elemental Encoder', path: '/integration-guides/3rd-party-encoders/aws' },
      { label: 'BirdDog', path: '/integration-guides/3rd-party-encoders/birddog' },
      { label: 'FFMPEG Source', path: '/integration-guides/3rd-party-encoders/ffmpeg' },
      { label: 'Grabyo', path: '/integration-guides/3rd-party-encoders/grabyo' },
      { label: 'Haivision Encoder', path: '/integration-guides/3rd-party-encoders/haivision' },
      { label: 'LiveU Encoder', path: '/integration-guides/3rd-party-encoders/liveu' },
      { label: 'OBS', path: '/integration-guides/3rd-party-encoders/obs' },
      { label: 'Osprey Video', path: '/integration-guides/3rd-party-encoders/ospreyvideo' },
      { label: 'Videon Encoder', path: '/integration-guides/3rd-party-encoders/videon' },
      { label: 'vMix Encoder', path: '/integration-guides/3rd-party-encoders/vmix' },
      { label: 'Wirecast', path: '/integration-guides/3rd-party-encoders/wirecast' },
    ],
  },
  {
    label: 'Clients',
    path: '/integration-guides/clients/client-overview',
    openNested: true,
    submenu: [
      { label: 'Amino', path: '/integration-guides/clients/amino' },
      { label: 'Bitmovin Plugin', path: '/integration-guides/clients/bitmovin' },
      { label: 'MultiView App', path: '/integration-guides/clients/multiviewapp' },
      { label: 'Video.js Plugin', path: '/integration-guides/clients/videojs' },
    ],
  },

  {
    label: 'Advanced Integrations',
    path: '/integration-guides/advanced-integrations',
    openNested: true,
    submenu: [
      { label: 'Singular Overlays', path: '/integration-guides/singular-live-overlays' },
      { label: 'Restreaming', path: '/integration-guides/restream' },
      { label: 'Transcription and Translation', path: '/integration-guides/translation' },
    ],
  },


];